<div id="site-info-images-grid" class="col-lg-5">
<div class="desc">ACT Performance Metrics for All Sites</div>
	<div class="wrapper">
		<div class="container">
			<div class="grid-container fixed-height" style="display:block;">
				<ul class="rig columns-2">
					<li class="iconic">
						<img src="/images/icon_chargers.png" class="small">
						<h3>{{sitesEstimatedCounts.total_chargers | number:'1.0-0'}}</h3>
						<p>Quantum Chargers installed</p>
					</li>
					<li class="iconic">
						<img src="/images/icon_batteries.png" class="small">
						<h3>{{sitesEstimatedCounts.total_battviews | number:'1.0-0'}}</h3>
						<p>BattViews Installed</p>
					</li>
					<li class="iconic">
						<img src="/images/icon_kwhr_used.png" class="small">
						<h3>{{whrsUsed | number:'1.0-2'}}</h3>
						<p>{{whrsUnit}} Used</p>
					</li>
					<li class="iconic">
						<img src="/images/icon_ahrs_used.png" class="small">
						<h3>{{ahrsUsed | number:'1.0-2'}}</h3>
						<p>{{ahrsUnit}} Used</p>
					</li>
					<li class="iconic">
						<img src="/images/icon_charge_cycles.png" class="small">
						<h3>{{chargeCyclesDelivered | number:'1.0-2'}}{{chargeCyclesUnit}}</h3>
						<p>Charge Cycles Delivered</p>
					</li>
					<li class="iconic">
						<img src="/images/icon_data_records.png" class="small" />
						<h3>{{sitesEstimatedCounts.data_records_saved/1000000 | number:'1.0-1'}}M</h3>
						<p>Events Recorded</p>
					</li>
					<li class="iconic">
						<img src="/images/icon_kwhr_saved.png" class="small" />
						<h3>{{sitesEstimatedCounts.total_energy_kwhrs_saved | number:'1.0-0'}}</h3>
						<p>kWhrs Total Energy Saved</p>
					</li>
					<li class="iconic">
						<img src="/images/icon_co2_saving.png" class="small" />
						<h3>{{sitesEstimatedCounts.co2_saving | number:'1.0-0'}}</h3>
						<p>lbs CO2 Saved</p>
					</li>
					<li class="iconic">
						<img src="/images/icon_trees.png" class="small" />
						<h3>{{sitesEstimatedCounts.co2_saved_per_urban_tree_planted | number:'1.0-0'}}</h3>
						<p>Number of Trees Planted</p>
					</li>
				</ul>
			</div>
		</div>	
	</div>
</div>
